/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="ab3842c5-d1ed-44c2-bbe1-543d4e10da52" width="6.34" height="11" viewBox="0 0 6.34 11" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g id="f6b634a7-2eec-4d0f-8c49-e1c0eba30b16">
          <g id="b8146def-b103-4626-ad1d-9944a4fab6bf">
            <g id="ed0001ed-771f-48d4-acfb-1f6a3fb6df0a">
              <g id="f8c041b8-9930-4422-8996-0e57e4da4f44">
                <path id="ae77b34c-372f-4ec5-9259-af64cd259c2c" d="M.37.22A1,1,0,0,1,1.69.28l.09.09L6.34,6,1.71,10.7a1,1,0,0,1-1.41,0A1,1,0,0,1,.2,9.4l.08-.1L3.66,5.85.22,1.63A1,1,0,0,1,.28.31Z" transform="translate(0 0)" style={{
                  fill: '#005b9c',
                  fillRule: 'evenodd',
                }} className="icon-fill"/>
              </g>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CaratRightIcon';

export default Icon;
